import React from 'react';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';

import { shortId } from 'utils';

import styles from './TabMenu.module.scss';

export type TabMenuItem = {
  name: string;
  to: string;
};

export type TabsMenuProps = {
  className?: string;
  data: TabMenuItem[];
};

export const TabMenu: React.FC<TabsMenuProps> = ({ className, data }) => (
  <nav className={clsx(styles.root, className)}>
    <ul>
      {data.map(item => (
        <li key={shortId()}>
          <NavLink activeClassName={styles['is-active']} to={item.to}>
            {item.name}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);
